import { ISearchResult } from './search.i';

export class CSearchResult<T> implements ISearchResult<T> {
  matchCount = 0;
  matchList: T[] = [];
  secondSearch: boolean = false;

  constructor(source?: ISearchResult<T>) {
    if (source) {
      Object.assign(this, {
        matchCount: source.matchCount,
        matchList: source.matchList ? [...source.matchList] : source.matchList,
        secondSearch: source.secondSearch
      });
    }
  }
}
